import React from 'react';

export default function Download() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path d="M8.57,11.41A29.44,29.44,0,0,1,3.68,6.17a.68.68,0,0,1,0-.7.72.72,0,0,1,.62-.37H6.69A33.41,33.41,0,0,1,7.61.6,1.52,1.52,0,0,1,9,0a1.52,1.52,0,0,1,1.39.6,43.11,43.11,0,0,1,.92,4.5h2.43a.72.72,0,0,1,.62.37.7.7,0,0,1,0,.7,30.55,30.55,0,0,1-4.9,5.24.73.73,0,0,1-.86,0Zm6.51-1.62H18a30,30,0,0,1-.67,7.13A1.53,1.53,0,0,1,15.86,18H2.12A1.49,1.49,0,0,1,.68,16.94,28.88,28.88,0,0,1,0,9.79H2.93a35.89,35.89,0,0,0,.35,5.28H14.72A36,36,0,0,0,15.08,9.79Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Download/index.js